import React, { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { login, formatApiError } from "@/lib/adminApi";

const inputCls = "bg-brand-bg border-brand-border focus-visible:ring-brand-accent text-white h-12";

export function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await login(username.trim(), password);
      toast.success(`Vítejte, ${user.name || "majiteli"}.`);
      onLogin(user);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail, "Přihlášení se nezdařilo."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg text-white flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm bg-brand-surface border border-brand-border p-8 space-y-5"
      >
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 border border-brand-accent text-brand-accent flex items-center justify-center">
            <Lock size={16} />
          </span>
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">Car Spa</div>
            <div className="font-display font-black text-xl leading-tight">Přehled rezervací</div>
          </div>
        </div>
        <Input
          data-testid="admin-login-username"
          type="text"
          placeholder="Uživatelské jméno"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className={inputCls}
        />
        <Input
          data-testid="admin-login-password"
          type="password"
          placeholder="Heslo"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={inputCls}
        />
        {error && (
          <div data-testid="admin-login-error" className="text-sm text-red-400">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full h-12 bg-brand-accent text-black font-semibold hover:bg-brand-accentHover transition-all disabled:opacity-60"
        >
          {loading ? "Přihlašuji..." : "Přihlásit se"}
        </button>
      </form>
    </div>
  );
}
